import { render, staticRenderFns } from "./Appoint.vue?vue&type=template&id=1d790654&scoped=true&"
import script from "./Appoint.vue?vue&type=script&lang=js&"
export * from "./Appoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d790654",
  null
  
)

export default component.exports